
import Modal from "../common/Modal/Modal";
import Button from "../Button/Button";

type OrderErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  statusLabel: string;
  message?: string | null;
  title: string;
  onRetry?: () => void;
  retryLabel?: string;
};

const OrderErrorModal = ({ isOpen, onClose, statusLabel, message, title, onRetry, retryLabel }: OrderErrorModalProps) => {
  const trimmedMessage = message?.trim();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
    >
      <div className="space-y-3 text-sm">
        <p className="font-semibold">{"Status"}: {statusLabel}</p>
        {trimmedMessage ? (
          <p className="text-gray-700 whitespace-pre-wrap">
            <span className="font-semibold">{"Mensagem"}: </span>
            {trimmedMessage}
          </p>
        ) : (
          <p className="text-gray-500">{"Nenhuma mensagem de erro foi retornada."}</p>
        )}
        {onRetry && (
          <div className="flex justify-end pt-2">
            <Button
              className="w-full sm:w-auto text-sm px-4 py-2"
              onClick={onRetry}
            >
              {retryLabel ?? "RE-EMITIR"}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default OrderErrorModal;
